var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m628.69 546.66-51.188-82.645v-0.26172-288.75c0-2.3203-0.92188-4.5469-2.5625-6.1875s-3.8672-2.5625-6.1875-2.5625h-45.414c-4.832 0-8.75 3.918-8.75 8.75s3.918 8.75 8.75 8.75h36.664v271.25h-420v-271.25h37.711c4.8359 0 8.75-3.918 8.75-8.75s-3.9141-8.75-8.75-8.75h-46.461c-4.832 0-8.75 3.918-8.75 8.75v288.75 0.26172l-51.188 82.645c-1.6641 2.6992-1.7383 6.0859-0.19531 8.8555 1.543 2.7656 4.4648 4.4844 7.6328 4.4883h542.5c3.168-0.003906 6.0898-1.7227 7.6328-4.4883 1.543-2.7695 1.4688-6.1562-0.19531-8.8555z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.75 105.48c-0.03125-2.3242-0.95312-4.5508-2.582-6.2109l-96.25-96.688c-1.6328-1.6445-3.8516-2.5703-6.168-2.582h-175c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375v122.5c0 2.3203 0.92188 4.5469 2.5625 6.1875s3.8672 2.5625 6.1875 2.5625h280c2.3203 0 4.5469-0.92188 6.1875-2.5625s2.5625-3.8672 2.5625-6.1875zm-96.25-75.469 66.414 66.672-66.414 0.003906z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490 166.25h-280c-4.832 0-8.75 3.918-8.75 8.75s3.918 8.75 8.75 8.75h280c4.832 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490 201.25h-280c-4.832 0-8.75 3.918-8.75 8.75s3.918 8.75 8.75 8.75h280c4.832 0 8.75-3.918 8.75-8.75s-3.918-8.75-8.75-8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m490 236.25h-280c-4.832 0-8.75 3.918-8.75 8.75v175c0 4.6406 1.8438 9.0938 5.125 12.375s7.7344 5.125 12.375 5.125h262.5c4.6406 0 9.0938-1.8438 12.375-5.125s5.125-7.7344 5.125-12.375v-175c0-2.3203-0.92188-4.5469-2.5625-6.1875s-3.8672-2.5625-6.1875-2.5625zm-114.89 135.62c-1.5703 2.7188-4.4766 4.3867-7.6133 4.375h-17.5v17.5c0 4.832-3.918 8.75-8.75 8.75s-8.75-3.918-8.75-8.75v-17.5h-17.5c-3.1094-0.035156-5.9648-1.7148-7.5039-4.418-1.543-2.6992-1.5312-6.0156 0.023437-8.707l26.25-43.75c1.582-2.6367 4.4297-4.25 7.5039-4.25 3.0703 0 5.9219 1.6133 7.5 4.25l26.25 43.75c1.5898 2.6914 1.625 6.0273 0.089843 8.75zm66.762-39.375c0 4.6406-1.8438 9.0938-5.125 12.375s-7.7344 5.125-12.375 5.125h-36.75l-10.5-17.5h47.25v-43.75h-148.75v43.75h29.75l-10.5 17.5h-19.25c-4.6406 0-9.0938-1.8438-12.375-5.125s-5.125-7.7344-5.125-12.375v-43.75c0-4.6406 1.8438-9.0938 5.125-12.375s7.7344-5.125 12.375-5.125h148.75c4.6406 0 9.0938 1.8438 12.375 5.125s5.125 7.7344 5.125 12.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.45 358.75h21.609l-10.805-17.98z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 625.625,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 86.054688,
    y: 625.625,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 96.839844,
    y: 625.625,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 111.679687,
    y: 625.625,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 126.4375,
    y: 625.625,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 136.894531,
    y: 625.625,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 151.730469,
    y: 625.625,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 175.007812,
    y: 625.625,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 190.664062,
    y: 625.625,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 212.539062,
    y: 625.625,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 236.667969,
    y: 625.625,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 251.613281,
    y: 625.625,
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 268.285156,
    y: 625.625,
    xlinkHref: "#y"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.207031,
    y: 625.625,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.148438,
    y: 625.625,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 314.203125,
    y: 625.625,
    xlinkHref: "#x"
  }), /*#__PURE__*/React.createElement("use", {
    x: 332.511719,
    y: 625.625,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    x: 351.105469,
    y: 625.625,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 367.140625,
    y: 625.625,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.507812,
    y: 625.625,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 404.449219,
    y: 625.625,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 418.386719,
    y: 625.625,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 647.5,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 79.515625,
    y: 647.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.304688,
    y: 647.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 105.332031,
    y: 647.5,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 135.742188,
    y: 647.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 146.199219,
    y: 647.5,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 161.773438,
    y: 647.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 184.222656,
    y: 647.5,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 202.53125,
    y: 647.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 217.558594,
    y: 647.5,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 233.132812,
    y: 647.5,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 256.320312,
    y: 647.5,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 272.355469,
    y: 647.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 283.140625,
    y: 647.5,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 298.171875,
    y: 647.5,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 305.667969,
    y: 647.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 320.503906,
    y: 647.5,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 333.472656,
    y: 647.5,
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.a10a8412019e410b8539d20938149639.svg";
export { ForwardRef as ReactComponent };